import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const SectionContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  max-width: ${breakpoints.xl};
  margin: auto;
  padding: ${spacing.space40} ${spacing.space48} ${spacing.space64} ${spacing.space48};
  flex-direction: column;
  row-gap: ${spacing.space120};

  @media (max-width: ${breakpoints.xl}) {
    padding-top: ${spacing.space48};
  }

  @media (max-width: ${breakpoints.l}) {
    padding: ${spacing.space24} ${spacing.space24} ${spacing.space64};
    row-gap: ${spacing.space48};
  }
`;

export const FrontPageHeroWrapper = styled.div`
  [class^='AnimateText__HideOverflow'] {
    position: absolute;
    bottom: ${spacing.space48};
    @media (max-width: ${breakpoints.m}) {
      bottom: ${spacing.space64};
    }
  }
`;
